import { createBrowserRouter } from "react-router-dom";
import RootLayoutRoute from "@/layouts/RootLayoutRoute";
import AuthLayoutRoute from "@/layouts/AuthLayoutRoute";
import CustomerLayoutRoute from "@/layouts/CustomerLayoutRoute";
import ProfileLayoutRoute from "@/layouts/ProfileLayoutRoute";
import SellerLayoutRoute from "@/layouts/SellerLayoutRoute";
import PrivacyPolicyLayoutRoute from "./layouts/PrivacyPolicyLayoutRoute";
import LandingContainer from "@/app/page";
import CustomerSignupForm from "@/app/components/auth/signup/CustomerSignupForm";
import HomeScreen from "@/app/components/home/Home";
import CategoriesPage from "@/app/categories/page";
import Cart from "@/app/components/cart/Cart";
import ProfilePage from "@/app/profile/page";
import ProfileEditPage from "@/app/profile/edit/page";
import WishlistPage from "@/app/wishlist/page";
import HelpPage from "@/app/help/page";
import HelpRaisePage from "@/app/help/raise/page";
import HelpPastQueriesPage from "@/app/help/past-queries/page";
import OrdersPage from "@/app/orders/page";
import InvoicesPage from "@/app/invoices/page";
import ProductPage from "@/app/products/page";
import PaymentSuccessPage from "@/app/payment/success/page";
import WalletPage from "@/app/wallet/page";
import SellerPage from "@/app/seller/page";
import SellerDashboardPage from "@/app/seller/dashboard/page";
import SellerInvoicesPage from "@/app/seller/invoices/page";
import SellerMyShopPage from "@/app/seller/my-shop/page";
import SellerAddProductPage from "@/app/seller/my-shop/add-product/page";
import SellerEditProductPage from "@/app/seller/my-shop/product/page";
import SellerSignupForm from "@/app/components/auth/signup/seller/SellerSignupForm";
import NotFound from "@/app/not-found";
import ErrorPage from "@/app/error";
import ForgotPassword from "./app/components/auth/forgotPassword/ForgotPassword";
import Login from "./app/components/auth/login/Login";
import { routes } from "./lib/constants";
import { UserPrivacyPolicy } from "./app/components/auth/signup/UserPrivacyPolicyDialog";
import { UserTermsAndConditions } from "./app/components/auth/signup/UserTermsAndConditionsDialog";
import { SellerPrivacyPolicy } from "./app/components/auth/signup/seller/SellerPrivacyPolicyDialog";
import { SellerTermsAndConditions } from "./app/components/auth/signup/seller/SellerTermsAndConditionsDialog";
import DeleteAccount from "./app/components/profile/DeleteAccount";
import MyReferrals from "./components/referral/MyReferrals";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayoutRoute />,
    errorElement: <ErrorPage />,
    children: [
      { path: routes.landing, element: <LandingContainer /> },
      {
        element: <PrivacyPolicyLayoutRoute />,
        children: [
          { path: routes.privacyPolicy.user, element: <UserPrivacyPolicy /> },
          {
            path: routes.termsAndConditions.user,
            element: <UserTermsAndConditions />,
          },
          {
            path: routes.privacyPolicy.seller,
            element: <SellerPrivacyPolicy />,
          },
          {
            path: routes.termsAndConditions.seller,
            element: <SellerTermsAndConditions />,
          },
        ],
      },
      {
        element: <AuthLayoutRoute />,
        children: [
          { path: routes.auth.login, element: <Login /> },
          { path: routes.auth.signup, element: <CustomerSignupForm /> },
          { path: routes.auth.forgotPassword, element: <ForgotPassword /> },
        ],
      },
      {
        element: <CustomerLayoutRoute />,
        children: [{ path: routes.home, element: <HomeScreen /> }],
      },
      {
        element: <ProfileLayoutRoute />,
        children: [
          {
            path: "/categories/:categoryId?/:subCategoryId?/:subSubCategoryId?",
            element: <CategoriesPage />,
          },
          { path: routes.cart, element: <Cart /> },
          { path: routes.profile.index, element: <ProfilePage /> },
          { path: routes.profile.edit, element: <ProfileEditPage /> },
          { path: routes.profile.deleteAccount, element: <DeleteAccount /> },
          { path: routes.profile.myReferrals, element: <MyReferrals /> },
          { path: routes.wishlist, element: <WishlistPage /> },
          { path: routes.help.index, element: <HelpPage /> },
          { path: routes.help.raise, element: <HelpRaisePage /> },
          {
            path: routes.help.pastQueries,
            element: <HelpPastQueriesPage />,
          },
          { path: routes.orders.index, element: <OrdersPage /> },
          { path: routes.invoices.index, element: <InvoicesPage /> },
          { path: "/invoices/:id", element: <InvoicesPage /> },
          { path: routes.payment.success, element: <PaymentSuccessPage /> },
          { path: routes.wallet.index, element: <WalletPage /> },
        ],
      },
      { path: routes.products.index, element: <ProductPage /> },
      { path: "/products/:id", element: <ProductPage /> },
      { path: "/products/:id/:variant", element: <ProductPage /> },
      {
        element: <SellerLayoutRoute />,
        children: [
          { path: routes.seller.index, element: <SellerPage /> },
          { path: "/seller/:id", element: <SellerPage /> },
          { path: routes.seller.signup, element: <SellerSignupForm /> },
          { path: routes.seller.dashboard, element: <SellerDashboardPage /> },
          { path: routes.seller.invoices, element: <SellerInvoicesPage /> },
          { path: routes.seller.myShop.index, element: <SellerMyShopPage /> },
          {
            path: routes.seller.myShop.addProduct,
            element: <SellerAddProductPage />,
          },
          {
            path: routes.seller.myShop.product.index,
            element: <SellerEditProductPage />,
          },
          {
            path: "/seller/my-shop/product/:id",
            element: <SellerEditProductPage />,
          },
        ],
      },
      { path: "*", element: <NotFound /> },
    ],
  },
]);
